import { useDispatch } from 'react-redux';

import colors from 'theme/Colors.module.scss';

import { Box, Text, CloseButton, Slide, Fade } from '@chakra-ui/react';

import { closeNotification } from 'modules/notifications/notificationsSlice';

const NotificationToast = ({ notificationData, open, offset }) => {
  const dispatch = useDispatch();
  const { id, title, message, type = 'info' } = notificationData;

  const bg =
    {
      success: colors.status00,
      error: colors.status100,
      info: colors.cyan,
      warning: colors.status50,
    }[type] || colors.grey400;

  return (
    <Slide direction="bottom" in={open} style={{ zIndex: 140 }}>
      <Fade in={open}>
        <Box
          position="fixed"
          bottom={`${offset}px`}
          right="20px"
          bg={bg}
          p={4}
          w="300px"
          color="white"
          boxShadow="lg"
          borderRadius="md"
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box display="flex" alignItems="center" gap={2}>
              <Box fontSize="1.4rem">
                {type === 'success' && <i className="fas fa-check-circle" />}
                {type === 'error' && (
                  <i className="fas fa-circle-exclamation" />
                )}
                {type === 'warning' && (
                  <i className="fas fa-exclamation-triangle" />
                )}
                {type === 'info' && <i className="fas fa-info-circle" />}
              </Box>
              <Box>
                {title && (
                  <Text fontWeight="bold" mb={1}>
                    {title}
                  </Text>
                )}
                <Text fontSize="sm">{message}</Text>
              </Box>
            </Box>
            <CloseButton
              size="sm"
              onClick={() => dispatch(closeNotification(id))}
            />
          </Box>
        </Box>
      </Fade>
    </Slide>
  );
};

export default NotificationToast;
